import React, { ReactElement } from 'react';

import { T } from '@/utils/common';

import { Injector, ParsedNode } from './types';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const h2r = require('html-to-react');

const processNode = new h2r.ProcessNodeDefinitions(React);

const parser = new h2r.Parser();

export type HTMLtoJSXProps = {
  html: string;
  injectors?: Injector[];
};

export function HTMLtoJSX(props: HTMLtoJSXProps) {
  const injectors = props.injectors || [];

  const instructions = [
    ...injectors.map(injector => ({
      shouldProcessNode: (node: ParsedNode) => injector(node, [], 0, processNode.processDefaultNode) != null,
      processNode: (node: ParsedNode, children: ReactElement[], index: number) =>
        injector(node, children, index, processNode.processDefaultNode),
    })),
    {
      shouldProcessNode: T,
      processNode: processNode.processDefaultNode,
    },
  ];

  return parser.parseWithInstructions(props.html, T, instructions);
}
